import { Reveal, Overline } from "./Reveal";
import { PROCESS } from "../data/content";

export const Process = () => (
  <section
    className="relative border-y border-white/5 bg-[#101010]"
    data-testid="process-section"
  >
    <div className="mx-auto max-w-[1400px] px-6 py-28 lg:px-10 lg:py-40">
      <div className="mb-16 max-w-2xl">
        <Reveal>
          <Overline>{PROCESS.overline}</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-4xl tracking-tight text-white sm:text-5xl">
            {PROCESS.title}
          </h2>
        </Reveal>
      </div>

      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {PROCESS.steps.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.1}>
            <div
              className="group h-full border-t border-white/15 pt-6"
              data-testid={`process-${s.no}`}
            >
              <span className="font-serif text-6xl italic text-zinc-800 transition-colors duration-500 group-hover:text-gold/70">
                {s.no}
              </span>
              <h3 className="mt-6 font-serif text-2xl text-white">{s.name}</h3>
              <p className="mt-3 text-base leading-relaxed text-zinc-400">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
